import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, EventEmitter, Input, Output, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { PrimeNgModule } from 'src/app/shared/prime-ng/prime-ng.module';
import { FieldLabelsAntecedentes, ObtencionGenerica } from '../interface/ver-proyecto.interface';
import { ProyectoService } from '../../../services/proyecto.service';
import Swal from 'sweetalert2';
import { LoginServices } from 'src/app/auth/login/services/login.service';

@Component({
  selector: 'app-display-antecedentes',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    NgIf,
    TagModule,
    AccordionModule,
    TabViewModule,
    TableModule,
    TooltipModule,
    InputNumberModule,
    PrimeNgModule
  ],
  templateUrl: './display-antecedentes.component.html',
  styleUrl: './display-antecedentes.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayAntecedentesComponent {


  //* Se recibe el registro profesional desde el componente padre
  @Input() registro: ObtencionGenerica = {};
  @Input() numDocumento!: string;
  @Input() numResolucion!: string;
  @Input() registroProfesional_Antecedentes!: ObtencionGenerica[];

  mostrarDialogo: boolean = false;
  fechaVencimiento: Date | null = null;
  fechaOtorgamiento: Date | null = null;
  showLoader:WritableSignal<boolean> = signal(false);
  selectedAntecedente: ObtencionGenerica | null = null;


  // Se definen los labels de los campos que se mostraran en la vista
  private fieldLabels = FieldLabelsAntecedentes;


  // Constructor de la clase
  constructor(private datePipe: DatePipe, private proyectoService: ProyectoService, public ls: LoginServices, private cdRef: ChangeDetectorRef) { }


  // Se define el objeto que se mostrara en la vista
  getFormDataArray(): Array<{ key: string, value: any, numeroResolucion: string }> {
    return Object.keys(this.fieldLabels)
      .filter(key => this.getNestedValue(key) !== undefined)
      .map(key => ({
        key,
        value: this.getNestedValue(key),
        numeroResolucion: this.registro['numResolucion']
      }));
  }

  // Se obtiene el valor del objeto anidado
  getNestedValue(key: string): any {
    const keys = key.split('.');
    let value = this.registro;

    for (const k of keys) {
      if (value && Object.hasOwn(value, k)) {
        value = value[k];
      } else {
        return undefined;
      }
    }
    return value;
  }


  // Se obtiene el label del campo
  getLabel(key: keyof typeof this.fieldLabels): string {
    return this.fieldLabels[key];
  }


  // Se obtiene el valor formateado del campo
getFormattedValue(value: any): string {
  if (!value) return '';

  // Verificar si el valor es una cadena con formato ISO de fecha
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    // Dividir la fecha en partes (año, mes, día) para evitar ajustes de zona horaria
    const [year, month, day] = value.split('-').map(Number);
    if (year && month && day) {
      // Crear una fecha sin ajustes de zona horaria
      return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    }
  }

  // Verificar si el valor es un objeto Date
  if (value instanceof Date && !isNaN(value.getTime())) {
    return this.datePipe.transform(value, 'dd/MM/yyyy') || '';
  }

  // Si no es una fecha, devolver el valor como cadena
  return value.toString();
}
  abrirDialogoFechas() {
    this.selectedAntecedente = this.registro;
    this.mostrarDialogo = true;
  }

  cancelarDialogo() {
    this.mostrarDialogo = false;
    this.fechaOtorgamiento = null;
    this.fechaVencimiento = null;
    this.cdRef.detectChanges();
  }
  
  guardarFecha() {
      if (!this.fechaOtorgamiento || !this.fechaVencimiento) return;
      this.showLoader.set(true);
      const payload = {
          numResolucion: this.selectedAntecedente!['numResolucion'] ?? this.registro!['numResolucion'],
          numDocumento: this.numDocumento!,
          fechaOtorgamientoPermiso: this.formatDate(this.fechaOtorgamiento!),
          fechaVencimientoPermiso: this.formatDate(this.fechaVencimiento!)
      };
      this.proyectoService.actualizarFechaMigraciones(payload).subscribe({
          next: (result) => {
            this.cancelarDialogo();
          },
          complete: () => {
            this.actualizarFechasLocal(payload.fechaOtorgamientoPermiso, payload.fechaVencimientoPermiso, payload.numResolucion);
            this.cancelarDialogo();
            this.showLoader.set(false);
            Swal.fire({
              icon: 'success',
              text: 'Fecha actualizada correctamente'
            });
          },
          error: (error) => {
            this.cancelarDialogo();
            console.log(error)
            this.showLoader.set(false);
            Swal.fire({
              icon: 'error',
              text: error.error?.message
            });
          }
      });
      
  }

  actualizarFechasLocal(fechaOtorgamiento: string, fechaVencimiento: string, numResolucion: string) {
    const index = this.registroProfesional_Antecedentes.findIndex(
      ant => ant['numResolucion'] === numResolucion
    );

    if (index >= 0) {
      this.registroProfesional_Antecedentes[index] = {
        ...this.registroProfesional_Antecedentes[index],
        fechaOtorgamientoPermiso: fechaOtorgamiento,
        fechaVencimientoPermiso: fechaVencimiento
      };
    }
  }
  
  private formatDate(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
  }
}